
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2023
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	// Application Title
	'appTitle': 'Project Gemini',
	'appExit': 'Hoş Geldiniz sayfasına git',


	'widgetsListLabel': 'Pencere öğeleri listesi. Bir pencere öğesi seçin ve eklemek için Enter tuşuna basın.',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	//General
	'listSeparator': ', ',
	'pointSeparator': ':',

	'insync': 'Güncel',
	'dirty': 'Güncel değil',
	'conflict': 'Görünüm kaydedilirken çakışma oluştu',
	'error': 'Görünüm kaydedilirken sorun oluştu',
	'failure': 'Sunucu ile iletişim kurulamıyor',
	'saveFailed': 'Görünüm kaydedilemiyor',

	'wa_insync': 'Kaydedildi',
	'wa_conflict': 'Görünüm kaydedilirken çakışma oluştu',
	'wa_error': 'Görünüm kaydedilemiyor',
	'wa_failure': 'Sunucu ile iletişim kurulamıyor',

	// Menu Labels
	'changeDisplay': 'Görüntüyü değiştir',
	'changeToColumnChart': 'Sütun grafiğe değiştir',
	'changeToBubbleChart': 'Kabarcık grafiğine değiştir',
	'toggleMoveHandles': 'Taşıma tutamaçlarını aç/kapat',
	'undo': 'Geri Al',
	'redo': 'Yinele',
	'mode': 'Kipi değiştir',

	'untitled': 'Başlıksız',
	'remove': 'Kaldır',
	'editTitle': 'Başlığı düzenle',
	'edit': 'Düzenle',
	'done': 'Bitti',

	// Data tray
	'dataTrayHandleOpenLabel': 'Veri tepsisini aç',
	'dataTrayHandleCloseLabel': 'Veri tepsisini kapat',

	// Dialogs
	'dlg_loading': 'Yükleniyor...',
	'dlg_ok': 'Tamam',
	'dlg_create': 'Oluştur',
	'dlg_cancel': 'İptal',
	'dlg_close': 'Kapat',
	'dlg_update': 'Güncelle',
	'dlg_renameBoardTitle': 'Bu nesneyi yeniden adlandır',
	'dlg_renameDatasetTitle': 'Bu veri kümesini yeniden adlandır',
	'dlg_renameSceneTitle': 'Bu sahneyi yeniden adlandır',
	'dlg_NameLabel': 'Adı:',
	'dlg_NewNameLabel': 'Yeni ad:',
	'dlg_DefaultNameWithDataSet': '%{name} Görünümü',
	'dlg_ShareTitle': 'İçeriği paylaş',
	'dlg_UnshareTitle': 'İçerik paylaşımını kaldır',
	'dlg_ShareUser': 'Kullanıcı Kimliği:',
	'dlg_NewColumnLabel': 'Yeni hesaplama adı',

	'dlg_new': 'Yeni...',
	'dlg_open': 'Aç...',
	'dlg_makeACopy': 'Kopya oluştur',
	'dlg_rename': 'Yeniden adlandır...',
	'dlg_moreToCome': 'Diğer eylemler geliyor...',

	'dlg_use': 'Kullan',

	'dlg_RelinkDatasetTitle': '\'%{datasetName}\' veri kümesini şununla değiştir ...',

	'open_error': 'Görünüm açılırken bir sorun oluştu.',

	// Delete Board
	'del_dialogTitle': 'Silmeyi onayla',
	'del_itemMsg': '\'%{name} öğesini silmek istediğinizden emin misiniz?',
	'del_itemsMsg': '%{count} öğeyi silmek istediğinizden emin misiniz?',
	'del_deleteErr': '\'%{name}\' silinemiyor',

	// List Sorting
	'dlg_ascending': 'artan',
	'dlg_descending': 'azalan',
	'dlg_custom': 'özel',
	'dlg_none': 'yok',

	// Input Placeholders
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'search': 'Ara',

	'searchHint': 'Tüm verilerinizde arayın',
	'clearSearchResult': 'Arama sonuçlarını temizle',
	// Shapes and shapes categories
	// Basic shapes
	'shapesCircle': 'Daire',
	'shapesHexagon': 'Altıgen',
	'shapesLine': 'Çizgi',
	'shapesOctagon': 'Sekizgen',
	'shapesPentagon': 'Beşgen',
	'shapesSquare': 'Kare',
	'shapesTriangle': 'Üçgen',
	'shapesDiamond': 'Baklava',
	'shapesTitle': 'Şekil özellikleri', // TODO: becomes "Shape" when FF 'PropertiesV2' is enabled


	// Advanced shapes
	'shapesSquareRounded': 'Yuvarlatılmış kare',
	'shapesStar': 'Yıldız',
	'shapesChevron': 'Köşeli çift ayraç',
	'shapesBadge_ribbon': 'Rozet şeridi',
	'shapesBadge': 'Rozet',
	'shapesHeart': 'Kalp',
	'shapesExclamation': 'Ünlem',
	'shapesTrendingup': 'Yukarı ilerleme',
	'shapesTrendingdown': 'Aşağı iniş',
	'shapesX': 'X',

	// People shapes
	'shapesPeopleCat': 'Kişiler',
	'shapesFemale': 'Kadın',
	'shapesHappyface': 'Mutlu surat',
	'shapesMale': 'Erkek',
	'shapesMan': 'Adam',
	'shapesNeutralface': 'İfadesiz yüz',
	'shapesSadface': 'Mutsuz yüz',
	'shapesShakehands': 'Tokalaşma',
	'shapesThumbsdown': 'Başparmak aşağı',
	'shapesThumbsup': 'Başparmak yukarı',
	'shapesWoman': 'Kadın',

	// Weather and places
	'shapesPlacesWeatherCat': 'Yerler & hava durumu',
	'shapesCity': 'Şehir',
	'shapesCloud': 'Bulut',
	'shapesEducation': 'Eğitim',
	'shapesGovernment': 'Devlet',
	'shapesHalfcloud': 'Yarım bulut',
	'shapesHouse': 'Ev',
	'shapesMoon': 'Ay',
	'shapesRain': 'Yağmur',
	'shapesSunny': 'Güneşli',

	//Vehicles
	'shapesVehiclesCat': 'Araçlar',
	'shapesAirplane': 'Uçak',
	'shapesCar': 'Otomobil',
	'shapesShip': 'Gemi',
	'shapesShoppingcart': 'Alışveriş sepeti',
	'shapesTrain': 'Tren',
	'shapesTruck': 'Kamyon',

	//Objects
	'shapesObjectsCat': 'Nesneler',
	'shapesBook': 'Kitap',
	'shapesBriefcase': 'Evrak Çantası',
	'shapesCalendar': 'Takvim',
	'shapesCheck': 'Çek',
	'shapesClock': 'Saat',
	'shapesDesktop': 'Masaüstü',
	'shapesDocument': 'Belge',

	'shapesFood': 'Yiyecek',
	'shapesGear': 'Dişli',
	'shapesHealth': 'Sağlık',

	'shapesIdea': 'Fikir',
	'shapesMobile': 'Mobile',
	'shapesMoney_bill': 'Kağıt para',
	'shapesMoney_coin': 'Bozuk para',
	'shapesPiggybank': 'Kumbara',
	'shapesStackofpaper': 'Kağıt yığını',
	'shapesStickynote1': 'Yapışkan not 1',
	'shapesStickynote2': 'Yapışkan not 2',
	'shapesTarget': 'Hedef',
	'shapesTool': 'Araç',

	'shapesUmbrella': 'Şemsiye',

	'shapesBrain': 'Beyin',
	'shapesSkull': 'Kafatası',
	'shapesEye': 'Göz',

	// Arrows shapes
	'shapesArrowsCat': 'Oklar',
	'shapesRightArrow': 'Sağ ok',
	'shapesLeftArrow': 'Sol ok',
	'shapesDoubleArrow': 'Çift ok',
	'shapesCurvedArrow': 'Kavisli ok',

	// Callouts shapes
	'shapesCalloutsCat': 'Açıklama Kutuları',
	'shapesRectCallout': 'Açıklama Kutusu',

	// Images
	'imagesCat': 'Resimler',
	'imageWidgetTitle': 'Resim pencere öğesi',
	'imgUrl': 'Resim URL\'si',
	'noImgSelected': 'Resim seçilmedi',
	'enterImgUrl': 'Resim URL\'sini buraya girin',
	'imgPasteLink': 'URL\'yi yapıştırın ve kaydetmek için Enter tuşuna basın.',
	'imgResizeToFit': 'Resmin boyutuna sığacak şekilde yeniden boyutlandır',
	'imgHeight': 'Yükseklik:',
	'imgWidth': 'Genişlik:',
	'imgTransparency': 'Saydamlık:',
	'imgMissingUrl': 'Resim URL\'si eksik.',
	'imgUrlValidationError': 'Resim URL\'si geçerli değil.',
	'imgUrlInvalidDomainError': 'Resim URL\'si, sistem yöneticiniz tarafından onaylanmamış bir etki alanını işaret ediyor. Yöneticiniz tarafından onaylanan etki alanları "%{domains}".',
	'notPositiveNumberError': 'Yalnızca pozitif değerler',

	// line shape
	'propStrokeWidth': 'Çizgi kalınlığı',
	'propStrokeDashArray': 'Çizgi stili',
	'propStrokeSolidline': 'Düz çizgi',
	'propStrokeLineCap': 'Çizgi başlığı',
	'propStrokeLineCapButt': 'Küt',
	'propStrokeLineCapRound': 'Yuvarlak',
	'propStrokeLineCapSquare': 'Kare',

	// Data player widget
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'playButtonLabel': 'Yürüt',
	'dataPlayerValueListLabel': 'Veri oynatıcı değerleri',
	// Text Widget
	'textWidgetTitle': 'Metin pencere öğesi',
	'textStyle': 'Stiller',
	'textStyleDescription': 'Önceden biçimlendirilmiş metin stilleri',
	'textTitleStyle': 'Başlık',
	'textTitleSmallStyle': 'Küçük başlık',
	'textSubtitleStyle': 'Alt başlık',
	'textBodyStyle': 'Gövde',
	'textBodySmallStyle': 'Küçük gövde',
	'textCaptionStyle': 'Başlık',
	'textQuoteStyle': 'Alıntı',
	'textQuoteSmallStyle': 'Küçük alıntı',
	'textResponsiveStyle': 'Otomatik boyut',
	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': 'İnce Çizgi',
	'textFontFamilySubClassThin': 'İnce',
	'textFontFamilySubClassThinItalic': 'İnce İtalik',
	'textFontFamilySubClassExtraLight': 'Ekstra İnce',
	'textFontFamilySubClassExtraLightItalic': 'Ekstra İnce İtalik',
	'textFontFamilySubClassLight': 'İnce',
	'textFontFamilySubClassLightItalic': 'İnce İtalik',
	'textFontFamilySubClassRegular': 'Normal',
	'textFontFamilySubClassRegularItalic': 'Normal İtalik',
	'textFontFamilySubClassItalic': 'İtalik',
	'textFontFamilySubClassMedium': 'Orta',
	'textFontFamilySubClassMediumItalic': 'Orta İtalik',
	'textFontFamilySubClassHeavy': 'Yoğun',
	'textFontFamilySubClassHeavyItalic': 'Yoğun İtalik',
	'textFontFamilySubClassDemiBold': 'Yarı Kalın',
	'textFontFamilySubClassDemiBoldItalic': 'Yarı Kalın İtalik',
	'textFontFamilySubClassBold': 'Kalın',
	'textFontFamilySubClassBoldItalic': 'Kalın İtalik',
	'textFontFamilySubClassExtraBold': 'Ekstra Kalın',
	'textFontFamilySubClassExtraBoldItalic': 'Ekstra Kalın İtalik',
	'textFontFamilySubClassBlack': 'Siyah',
	'textFontFamilySubClassBlackItalic': 'Siyah İtalik',
	'textFontFamilySubClassStencil': 'Kalem',
	// END: Remove FontFamilySubClass

	'responsiveCoachmarkTitle': 'Yazı tipini otomatik boyutlandır',
	'responsiveCoachmarkContents': 'Bu metin tipini yeniden boyutlandırdığınızda yazı tipi boyutu otomatik olarak sığacak şekilde yeniden boyutlandırılır. Metin özelliklerinde yazı tipi boyutunu ayarlayabilirsiniz.',

	'propText': 'Metin ayrıntıları', // TODO: no longer needed when FF 'PropertiesV2' is enabled, replaced with 'Details'
	'propTextReturn': 'Metin özellikleri', // TODO: becomes "Text" when FF 'PropertiesV2' is enabled

	'textFontSize': 'Yazı tipi boyutu',
	'textFontFamily': 'Yazı tipi ailesi',
	'textFontWeight': 'Yazı tipi ağırlığı', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'textFontColor': 'Renk',
	'textLineHeight': 'Satır yüksekliği',
	'textIndentation': 'Girintilendirme',
	'textIncreaseIndentation': 'Girintiyi arttır',
	'textDecreaseIndentation': 'Girintiyi azalt',
	'textInnerMargins': 'İç kenar boşlukları (px)',

	// Widget Properties
	'propImageLink': 'Resim bağlantısı',
	'propMissingURL': 'URL girin',
	'propImgTop': 'Resim özellikleri', // TODO: becomes "Image" when FF 'PropertiesV2' is enabled
	'propGeneralReturn': 'Genel özellikler', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyle': 'Genel', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyleReturn': 'Genel', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propFillColor': 'Dolgu rengi', // TODO: becomes "Background color" when FF 'PropertiesV2' is enabled
	'propTextColor': 'Metin rengi', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propBorderColor': 'Kenarlık rengi',
	'propBorderRadius': 'Köşe yarıçapı (px)',
	'propShowBorderInPreview': 'Seçilen kenarlığı önizlemede göster',
	'propMaintainAxisScales': 'Eksen ölçeğini koru',
	'propShowItemLabel': 'Öğe etiketini göster',
	'propHideLegend': 'Açıklamayı gizle',
	'propColorPalette': 'Palet',
	'propLegendPosition': 'Açıklama konumu',
	'propHideAxisTitleLabels': 'Eksen başlıklarını gizle',
	'propLineColor': 'Çizgi rengi',
	'propBubbleColor': 'Kabarcık rengi',
	'propInterpolation': 'Düz çizgiler',
	'propElementColor': 'Görselleştirme öğesi rengi',
	'propSymbolShape': 'Simge şekli',
	'propHeatScalePalette': 'Renk düzeni',
	'propHeatScalePalette_tooltipDarkerForLowerValue': 'Daha koyu renkler, daha küçük değerleri temsil eder.',
	'propHeatScalePalette_tooltipDarkerForHigherValue': 'Daha koyu renkler, daha büyük değerleri temsil eder.',
	'propImageDetails': 'Resim ayrıntıları', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propWebDetails': 'Web sayfası ayrıntıları', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propMediaDetails': 'Ortam ayrıntıları', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPasteLink': 'URL\'yi girin ve Enter tuşuna basın.',

	//Layout Properties
	'sectionName_positionAndStyle': 'Konum ve stil',
	'propPositionLabel': 'Konum', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPositionXAxis_v1': 'X',
	'propPositionXAxis': 'X konumu (%{unit})',
	'propPositionYAxis_v1': 'Y',
	'propPositionYAxis': 'Y konumu (%{unit})',
	'propResizeLabel': 'Boyut', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propResizeWidth_v1': 'Genişlik',
	'propResizeWidth': 'Genişlik (%{unit})',
	'propResizeHeight_v1': 'Yükseklik',
	'propResizeHeight': 'Yükseklik (%{unit})',
	'propRotateLabel_v1': 'Döndür',
	'propRotateLabel': 'Döndür (°)',
	'propRotateAngle': 'Açı', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'propScaleLabel': 'Simge miktarı',
	'propScaleDescription': 'Simgelerin miktarını seçin',
	'propScaleFew': 'Düşük',
	'propScaleDefault': 'Varsayılan',
	'propScaleMany': 'Yüksek',

	/* PropertyV2 controls */
	// InputLabel - number
	'propInputLabel_number_invalid': 'Bu değer sayısal olmalıdır',

	'mediaAriaLabel': 'url girişi',
	'dropdownAriaLabel' : 'Açılan Liste',
	'ariaGroupLabel': 'Açılan liste kategorisi: %{cateoryLabel} öğe: %{itemLabel}. Genişletmek için AŞAĞI tuşuna basın. Dolaşmak için YUKARI ve AŞAĞI tuşuna veya daraltmak için ESCAPE tuşuna basın.',
	'colorNoFillLabel': 'Dolgu yok',
	// Timer
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'lastRefresh': 'Son yenileme: %{timeInterval} önce',
	'widgetTimer': 'Pencere öğesi zamanlayıcısı',

	// Theme colors
	'transparent': 'Renk yok',
	'white': 'Beyaz',
	'lightGrey': 'Açık gri',
	'grey': 'Gri',
	'darkGrey': 'Koyu gri',
	'black': 'Siyah',
	'lightBlue': 'Açık mavi',
	'blue': 'Mavi',
	'darkBlue': 'Koyu mavi',
	'yellow': 'Sarı',
	'orange': 'Turuncu',
	'lime': 'Limon yeşili',
	'green': 'Yeşil',
	'peach': 'Şeftali',
	'red': 'Kırmızı',
	'violet': 'Menekşe',
	'aqua': 'Deniz Mavisi',
	'purple': 'Mor',
	'plum': 'mürdüm',
	'gray10': 'Gri 10',
	'gray20': 'Gri 20',
	'gray30': 'Gri 30',
	'gray50': 'Gri 50',
	'gray60': 'Gri 60',
	'gray70': 'Gri 70',
	'gray80': 'Gri 80',
	'gray90': 'Gri 90',
	'gray100': 'Gri 100',
	'blue50': 'Mavi 50',
	'blue60': 'Mavi 60',
	'blue70': 'Mavi 70',
	'green40': 'Yeşil 40',
	'green50': 'Yeşil 50',
	'red50': 'Kırmızı 50',
	'red60': 'Kırmızı 60',


	//Theme Palette Labels
	'themeLabel': 'Tema',
	'paletteLabel': 'IBM paleti %{number}',
	'heatPaletteLabel': 'IBM ısı paleti %{number}',
	'conditionalPaletteLabel': 'IBM koşullu paleti %{number}',
	'carbonPaletteXLight': 'Carbon X Açık',
	'carbonPaletteXDark': 'Carbon X Koyu',
	'carbonPalettePurple': 'Mor',
	'carbonPaletteTeal': 'Deniz mavisi',
	'carbonPaletteCyan': 'Cam göbeği',
	'carbonPaletteMagenta': 'Macenta',
	'carbonPalettePurpleTeal': 'Mor Deniz Mavisi',
	'carbonPaletteCyanMagenta': 'Cam Göbeği Macenta',
	'carbonPaletteGreenRed': 'Yeşil Kırmızı',
	'carbonPaletteGreenYellowRed': 'Yeşil Sarı Kırmızı',
	'carbonPalettePurpleTealConvergent': 'Mor Deniz Mavisi Yakınsak',
	'carbonPaletteCyanMagentaConvergent': 'Cam Göbeği Macenta Yakınsak',

	// TODO: Remove the following strings when the colour palette UI is removed
	'userPaletteColor_lightTheme': 'IBM ince paleti',
	'userPaletteColor_defaultTheme': 'IBM varsayılan paleti',
	'userPaletteColor_darkTheme': 'IBM kalın paleti',

	// Dashboard
	'propDashboardBackgroundColor': 'Arka plan rengi',
	'propLayoutPositioning': 'Düzen konumlandırma',
	'propLayoutRelative': 'Göreli',
	'propLayoutAbsolute': 'Mutlak',
	'propLayoutPositioningCoachmarkTitle': 'Bir düzen stili seçin',
	'propLayoutPositioningCoachmarkContent': 'Göreli düzende, pencere bileşenlerinin boyutu ve konumu ekrana sığdırılacak şekilde ayarlanır. Mutlak düzendeki pencere bileşenleri, ekran boyutuna bakılmaksızın tam olarak onu boyutlandırdığınız ve yerleştirdiğiniz şekilde görüntülenir.',
	'gridText': 'Izgarayı göster',
	'snapText': 'Izgaraya yasla',
	'snapObjectsText': 'Nesnelere yasla',
	'fitPageText': 'Sayfayı sığdır',
	'gridLabel': 'Kılavuz',
	'heightUnit': 'y',
	'widthUnit': 'g',
	'pixelUnit': 'px',
	'propPageSizeLabel': 'Sayfa boyutu',
	'propPageSizePresetAriaLabel': 'Sayfa boyutu önayarı',
	'propPageSizePreset_v1': 'Ön ayar',
	'propPageSizePreset': 'Sayfa boyutu',
	'propPageSizePresetCustom': 'Özel',
	'propPageSizePreset16x9': 'Ekran 16:9',
	'propPageSizePreset4x3': 'Ekran 4:3',
	'propPageSizePresetInfographic': 'İnfografik',
	'propPageSizeWidth_v1': 'Genişlik',
	'propPageSizeWidth': 'Genişlik (px):',
	'propPageSizeHeight_v1': 'Yükseklik',
	'propPageSizeHeight': 'Yükseklik (px):',
	'propPageSizeWidthAriaLabel': 'Sayfa boyutu genişliği',
	'propPageSizeHeightAriaLabel': 'Sayfa boyutu yüksekliği',
	'propPageSizeAdjustedMessage': 'Girdiniz minimum değerin altında olduğundan veya gösterge panonuza sığmadığından sayfa boyutu artırıldı.',
	'propTabShow': 'Sekmeleri göster',
	'propShowTabsInPreview': 'Sekmeleri önizlemede göster',
	'multilingualDashboardsLabel': 'Diller',
	'multilingualDashboardsDefault': '%{defaultLanguage} -- Varsayılan',
	'multilingualDashboardsAddLinkText': 'Başka bir dil ekle',
	'multilingualDashboardsSelect': 'Seç',
	'multilingualDashboardsButtonLabel': 'Ekle',
	'multilingualDashboardTranslationMode': 'Şu anda çeviri kipindesiniz (%{currentLanguage})',
	'multilingualDashboardTranslationDone': 'Bitti',
	'multilingualDashboardRemainingStrings': '%{numTranslationsLeft} çeviri kaldı',
	'multilingualDashboardRemainingString': '1 çeviri kaldı',
	'multilingualDashboardsSetDefault': 'Varsayılan dili ayarla',
	'multilingualDashboardIconMore': '%{currentLanguage} dili için diğer işlemler',
	'multilingualDashboardIconTranslatableArea': 'Çevrilebilir alan',
	'multilingualDeleteTitle': 'Dili sil',
	'multilingualDeleteLanguageWarning': '\'%{language}\' dilini silmek istediğinizden emin misiniz?',
	'multilingualSelectLanguage': 'Bir dil seçin',
	'confirmLayoutStyleUpgradeTitle': 'Tüm sekmelere uygula',
	'confirmLayoutStyleUpgrade': 'Bu düzen stili, gösterge panonuzdaki tüm sekmelere uygulansın mı?',
	'defaultBackgroundColorLabel': 'Varsayılan',

	//Tabs
	'tabDeleteDialogPrimaryButton': 'Sil',
	'tabDeleteDialogTitle': 'Bu sekme silinsin mi?',
	'tabDeleteDialogMessage': 'Bu sekmedeki tüm içerik de silinecek.',

	// Vis widget
	'propVisTypeReturn': 'Görselleştirme tipleri',
	'propVisDetails': 'Ayrıntılar',

	// Alignment picker
	'propAlignPickTop': 'Üste hizala',
	'propAlignPickRight': 'Sağa hizala',
	'propAlignPickBottom': 'Alta hizala',
	'propAlignPickLeft': 'Sola hizala',
	'propAlignPickCenter': 'Ortaya hizala',
	'propAlignPickMiddle': 'Ortaya hizala',
	'propAlignPicker': 'Yatay hizalama',
	'propVerticalAlignPicker': 'Dikey hizalama',

	// Toolbar picker
	'propToolbarPickBold': 'Kalın',
	'propToolbarPickUnderline': 'Altı çizili',
	'propToolbarPickItalic': 'İtalik',
	'propToolbarPickJustifyLeft': 'Sola hizala',
	'propToolbarPickJustifyCenter': 'Ortaya hizala',
	'propToolbarPickJustifyRight': 'Sağa hizala',
	'propToolbarPickJustify': 'İki yana hizala',

	'propList': 'Liste',
	'propOrderedList': 'Sıralı liste',
	'propUnorderedList': 'Sırasız liste',

	// Symbol shapes
	'propCircle': 'Daire',
	'propTriangle': 'Üçgen',
	'propSquare': 'Kare',
	'propRect': 'Dikdörtgen',
	'propStar': 'Yıldız',
	'propCross': 'Çapraz',
	'propPlus': 'Artı',
	'propPoly': 'Çokgen',


	// True and false selection
	'propTrue': 'Doğru',
	'propFalse': 'Yanlış',

	// Position selection
	'propLeft': 'Sol',
	'propRight': 'Sağ',
	'propTop': 'Üst',
	'propBottom': 'Alt',

	// Interpolation options
	'propSmooth': 'Düz',
	'propStraight': 'Düz',

	// indentedListView
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'srILVTreeLabel': 'Liste', // screen reader label for tree role

	// widget move
	'srWidgetMoveLeft': 'Sola taşı', // screen reader
	'srWidgetMoveUp': 'Yukarı taşı', // screen reader
	'srWidgetMoveRight': 'Sağa taşı', // screen reader
	'srWidgetMoveDown': 'Aşağı taşı', // screen reader

	// widget resize
	'srWidgetResizeBigger': 'Orantılı olarak boyutu artır', // screen reader
	'srWidgetResizeSmaller': 'Orantılı olarak boyutu azalt', // screen reader
	'srWidgetResizeBiggerV': 'Dikey olarak boyutu artır', // screen reader
	'srWidgetResizeSmallerV': 'Dikey olarak boyutu azalt', // screen reader
	'srWidgetResizeBiggerH': 'Yatay olarak boyutu artır', // screen reader
	'srWidgetResizeSmallerH': 'Yatay olarak boyutu azalt', // screen reader

	// widget rotate
	'srWidgetRotateCW': 'Saat yönünde çevir', // screen reader
	'srWidgetRotateCCW': 'Saat yönünün tersine çevir', // screen reader

	// Recommended types
	'visChange': 'Görselleştirmeyi değiştir',

	// Visualization
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'visualizationLabel': 'Görselleştirme',
	'chartLabel': '%{chartName} grafiği',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Pencere öğesi içinde dolaşmak için F12 tuşuna basın',
	'f10KeyDescription': 'Pencere öğesi odaklanma görünümünü başlatmak için F10 tuşuna basın',

	'WidgetLabelWithDescripion': '%{label}. %{description}',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'summaryLabel': '%{value} değerine sahip {label} %',

	'shapeColorLabel': 'Şekil rengi',
	'showLegendLabel': 'Açıklamayı göster',

	//Webpage
	'webpageWidgetTitle': 'Web sayfası pencere öğesi',
	'webpagePasteLink': 'URL\'yi yapıştırın ve kaydetmek için Enter tuşuna basın.',
	'propWebpageLink': 'Web sayfası URL\'si',
	'propWebpageTitle': 'Web sayfası başlığı',
	'propWebpageTitleDescription': 'Web sayfasının başlığı',
	'webpageUrl': 'Web sayfası URL\'si',
	'noWebpageSelected': 'Web sayfası seçilmedi',
	'enterWebpageUrl': 'Web sayfası URL\'sini buraya girin',
	'propWebpageTop': 'Web sayfası özellikleri', // TODO: becomes "Web page" when FF 'PropertiesV2' is enabled
	'webpageMissingUrl': 'Web sayfası URL\'si eksik.',
	'webpageUrlValidationError': 'Web sayfası URL\'si geçerli değil.',
	'webpageHttpValidationError': 'Web sayfasına bir HTTPS bağlantısı kullanılarak erişilmelidir. ',
	'webpageInvalidDomainError': 'Web sayfası URL\'si, sistem yöneticiniz tarafından onaylanmamış bir etki alanını işaret ediyor. Yöneticiniz tarafından onaylanan etki alanları "%{domains}".',

	//VizState
	'vzErrorLoading': 'Görselleştirme yüklenemiyor',
	'vzErrorLoadingMissingData': 'Görselleştirme yüklenemiyor, bağlam verileri eksik',

	//Media (Video / Audio)
	'mediaWidgetTitle': 'Ortam pencere öğesi',
	'mediaPasteLink': 'URL\'yi yapıştırın ve kaydetmek için Enter tuşuna basın.',
	'mediaUrl': 'Ortam URL\'si',
	'noMediaSelected': 'Ortam seçilmedi',
	'enterMediaUrl': 'Ortam URL\'sini buraya girin',
	'videoHeight': 'Yükseklik:',
	'videoWidth': 'Genişlik:',
	'propMediaLink': 'Ortam bağlantısı',
	'propMediaTitle': 'Ortam başlığı',
	'propMediaTitleDescription': 'Ortamın başlığı',
	'propMediaTop': 'Ortam özellikleri', // TODO: becomes "Media" when FF 'PropertiesV2' is enabled
	'mediaMissingUrl': 'Ortam bağlantısı URL\'si eksik.',
	'mediaUrlValidationError': 'Ortam dosyası URL\'si geçerli değil.',
	'mediaUnknownValidationError': 'Bu ortam tipi desteklenmiyor.',
	'mediaHttpValidationError': 'Ortam dosyasına bir HTTPS bağlantısı kullanılarak erişilmelidir. ',
	'mediaInvalidDomainError': 'Ortam dosyası URL\'si, sistem yöneticiniz tarafından onaylanmamış bir etki alanını işaret ediyor. Yöneticiniz tarafından onaylanan etki alanları "%{domains}".',

	// Properties pane
	'commonPropertiesLabel': 'Özellikler', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// Data strip
	'dataSetsLabel': 'Veri kümesi',
	'dataViewsLabel': 'Görünüm',
	'columnQuality': 'Veri kalitesi',
	'columnProperties': 'Veri özellikleri',

	'dataQuality': 'Veri kalitesi',
	'dataQualityRowCount': 'Satır sayısı',
	'dataQualityDistribution': 'Dağıtım',
	'dataRowLabel': 'Veri',

	// Modelling UI
	'typeColumn': 'Tip',
	'modellingColumnType': 'Tip',
	'modellingColumnAggregation': 'Toplama',
	'modellingColumnUsage': 'Kullanım',
	'modellingColumnSort': 'Sırala',
	'modellingColumnFormat': 'Biçim',
	'modellingColumnCategory': 'Kategori',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingLoading': 'Yükleniyor...',

	'modellingProcessing': 'İşleniyor...',
	'modellingImport': 'İçe Aktar',
	'modellingReimport': 'Yeniden içe aktar',
	'modellingDatasourceTitle': 'Veri kaynağı',
	'modellingImportStartedTitle': 'İçe aktarma başlatıldı',
	'modellingImportStartedText': 'Verilerinizin içe aktarılması biraz zaman alabilir.\n\n(Veriler içe aktarırken bir görünüm oluşturabilirsiniz.)',
	'importDatasourceTitle': 'Bağlantılar',
	'dropHere': 'Yeni bir veri kaynağı oluşturmak için buraya bırakın...',
	'browseButton': 'Göz At',
	'errorNoData': 'İşlenecek veri yok.',
	'errorNoFile': 'Karşıya yüklenecek dosya yok.',
	'errorUploadFailed': 'Karşıya yüklenemiyor.',
	'uploadSucceessful': 'Karşıya yükleme başarılı oldu!',
	'del_datasourceTitle': 'Veri kümesini sil',
	'del_datasourceMsg': '\'%{name}\' öğesini silmek istediğinizden emin misiniz?',
	'modellingFileUpdate': 'Güncelle',
	'modellingFileUpdateTitle': 'Veri kümesini güncelle',
	'modellingFileUpdateDescription': '\'%{name}\' öğesini güncellemek istiyor musunuz?',
	'modellingFileUpdatingTitle': '\'%{name}\' güncelleniyor',
	'modellingUpdateStartedTitle': 'İçe aktarmayı güncelleme başlatıldı',
	'modellingUpdateStartedText': 'Verilerinizin güncellenmesi biraz zaman alabilir.\n\n(Veriler güncellenirken bir görünüm oluşturabilirsiniz.)',
	'modellingErrorImportUploadNoFile': 'Karşıya yüklenecek dosya yok.',
	'modellingErrorImportUploadFailed': 'Karşıya yüklenemiyor.',
	'modellingErrorImportUploadInvalidType': 'Dosya tipi geçerli değil.',
	'modellingErrorImportUploadTableFailed': 'Tablolar alınamıyor.',
	'modellingIntentResultsTitle': 'Kullanılacak önerilen veri kümesini seçin',
	'modellingColumnViewRelationships': 'İlgili tabloları görüntüle',
	'modellingTableRelatedTables': '\'%{name}\' ile ilgili tablolar',
	'modellingTable': '%{name} - Tablo',
	'modellingColumnIncludedInDataSet': 'Eklendi',
	'modellingDataSet': 'Veri kümesi',
	'modellingViewInDataSet': 'Veri kümesinde görüntüle',
	'modellingViewRelatedTables': 'İlgili tabloları görüntüle',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingRelatedTablesNoneFound': 'İlgili tablo bulunamadı',

	'modellingValidatingDataset': 'Doğrulanıyor...',
	'datasetFinishedRefreshing': 'Veri kümesi %{datasetName} yenilendi.',



	// Join UI - Navigation Controller titles
	'modellingJoinTable': 'Birleşme yolunu çözümle:',
	'modellingJoinColumns': 'Tablo için bir birleşim yolu tanımlayın: %{name}',
	'modellingJoinToTable': 'Tabloya ekle: %{name}',

	// Data Quality
	'excluded': 'Hariç tutuldu',
	'metricPrefixThousand': 'K',
	'metricPrefixMillion': 'P',
	'metricPrefixBillion': 'B',
	'metricPrefixTrillion': 'P',
	'metricPrefixQuadrillion': 'Q',

	//Column Flyout
	'modellingColumnFilter': 'Süzgeç',
	'modellingColumnSortNone': 'Sıralamayı temizle',
	'modellingColumnSortAsc': 'Artan düzende sırala',
	'modellingColumnSortDesc': 'Azalan düzende sırala',
	'modellingColumnRemove': 'Bu sütunu kaldır',

	// Import File Browser
	'dropboxPageTitle': 'Yeni Dropbox bağlantısı',
	'sizeColumn': 'Boyut',

	//Modelling Column Property Values
	'dataType_string': 'Dizgi',
	'dataType_date': 'Tarih',
	'dataType_integer': 'Tam sayı',
	'dataType_double': 'Çift',
	'dataType_float': 'Float',
	'dataType_boolean': 'Boole',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'defaultAggregation_count': 'Say',
	'defaultAggregation_countdistinct': 'Farklıları say',
	'defaultAggregation_max': 'Maksimum',
	'defaultAggregation_min': 'Minimum',
	'defaultAggregation_avg': 'Ortalama',
	'defaultAggregation_sum': 'Toplam',
	'defaultAggregation_auto': 'Otomatik (%{aggregationType})',

	'type_fact': 'Olgu',
	'type_attribute': 'Öznitelik',

	'defaultSort_none': 'Sıralama!',
	'defaultSort_asc': 'Artan düzende sırala',
	'defaultSort_desc': 'Azalan düzende sırala',

	'category_none': 'Yok',
	'category_location': 'Yer',
	'category_monetary': 'Parasal',
	'category_time': 'Zaman',

	// Root menu
	'rootMenuTitle': 'Ana menü',

	'errorMessageTitle': 'Hata',
	'errorMessageDetails': 'Detaylar: ',
	'errorMessageTitleAssetAlreadyExists': 'Varlık zaten var',

	'defaultTabTitle': 'Sekme %{index}',
	'tabAddBtnTitle': 'Yeni bir sekme ekle',
	'defaultInfographicTitle': 'İnfografik',

	'unsupportedConditionalFormattingEncountered': 'Koşullu biçimlendirme artık bazı sütunlara uygulanmıyor.',


	// Homepage View
	'nameColumn': 'Ad',
	'creatorColumn': 'Oluşturan',
	'creationDateColumn': 'Oluşturulma tarihi',
	'versionColumn': 'Sürüm',
	'modifiedColumn': 'Son Değiştirme Zamanı',

	'filterBy': 'Öğeleri süz',
	'allFilter': 'Tüm öğeler',
	'createdByMeFilter': 'Benim tarafından oluşturulan',
	'sharedWithMeFilter': 'Benimle paylaşılan',
	'favoritesFilter': 'Sık kullanılanlarım',
	'recentsFilter': 'Son eklenen',
	'sortBy': 'Sıralama ölçütü',

	// Sort Menu
	'sortModified': 'Değiştirme',
	'sortUpdated': 'Güncellendi',
	'sortName': 'Ad',

	'viewAs': 'Görüntüleme biçimi',
	'thumbnailsView': 'Küçük resim olarak görüntüle',
	'listView': 'Liste olarak görüntüle',
	'createMenu': 'Oluştur',
	'newAppItem': 'Gösterge Panosu',
	'newDataSet': 'Veri kümesi',

	'menuSelectionState_a11y': '"%{item}" seçicisi, "%{selectedItem}" olarak ayarlandı',

	'unableToShareItem': '"%{item}" öğesi paylaşılamıyor.',
	'toastFetchingContent': 'Daha fazla içerik alınıyor...',
	'unableToGetData': 'İçerik alınamıyor.',
	'unableToFavorite': 'Sık Kullanılan durumu değiştirilemiyor.',
	'hpErrorMissingRequiredOptions': 'Gerekli başlatma seçenekleri eksik',
	'unableToOpenBoard': '"%{name}" açılamıyor.',
	'unableToDuplicateBoard': '"%{name}" çoğaltılamıyor.',
	'unableToCreateBoard': '"%{name}" oluşturulamıyor.',
	'unableToCreateBoardNameConflict': 'Aynı ada sahip bir varlık zaten var.',

	// DataSet Detail View
	'status': 'Durum',
	'numberOfRows': 'Satırlar',
	'importWarnings': 'Uyarılar',
	'lineNumbers': 'Satırlar',
	'excerptFromSource': 'Alıntı',
	'reason': 'Neden',
	'numberOfRowsDropped': 'satır bırakıldı',
	'oneRowDropped': '1 satır bırakıldı',

	// Type Menu
	'typeMenuLabel': 'Tip',
	'dashboardsLabel': 'Panolar',
	'datasetsLabel': 'Veri kümeleri',
	'storiesLabel': 'Hikayeler',
	'allLabel': 'Tüm tipler',

	// Board Page View App Bar
	'datasets': 'Veri kümeleri',
	'settings': 'Özellikler',
	'add': 'Ekle',
	'widgets': 'Pencere öğeleri',
	'dashboardProperties': 'Gösterge panosu özellikleri',
	'searchPanel' : 'Ara',
	'pins': 'Derlem',
	'pinsOld': 'Sabitlediklerim',
	'pinsDateFilterHeading' : 'Tarih Sabitlendi',
	// For languages with more than one plural form, provide the different forms delimited by |||| in the string below.
	// See https://github.com/airbnb/polyglot.js#pluralization
	'pinCount': '%{smart_count} sabitlenen |||| %{smart_count} sabitlenen',
	'pinSearch': 'Ara',
	'pinSearchOld': 'Sabitlenenleri ara',
	'pinListView': 'Liste görünümü',
	'pinIconView': 'Simge görünümü',
	'pinRemove': 'Kaldır',
	'pinCreate': 'Oluştur',
	'pinDeleteError': 'Derlemden bir veya daha fazla varlığı silemiyoruz. Daha sonra yeniden dene.',
	'pinDeleteErrorOld': 'Bir veya daha fazla işaretleneni silemiyoruz. Daha sonra yeniden dene.',
	'pinRetrieveError': 'Bir veya daha fazla işaretleneni alamıyoruz. Daha sonra yeniden dene.',
	'NoPinsCollected': 'Sabitlenmiş görselleştirme yok',
	'pinDeletedToast': 'Sabitleme kaldırıldı',
	'pinRenamedToast': 'Pin yeniden adlandırıldı',
	'pinAddedToast': 'Sabitleme başarıyla Sabitlediklerim\'e eklendi',
	'pinningToast': 'Sabitleme işleniyor...',
	'pinDateFilter': 'Tarih Süzgeci',
	'pinDateFilterAll': 'Tümü',
	'pinDateFilterToday': 'Bugün',
	'pinDateFilterYesterday': 'Dün',
	'pinDateFilterPastWeek': 'Geçen hafta',
	'pinDateFilterPastMonth': 'Geçen ay',
	'pinDateFilterEarlier': 'Daha önce',

	// data widget contextual toolbar labels
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'toolbarActionEditTitle': 'Başlığı düzenle',
	'toolbarActionSort': 'Sırala',
	'toolbarActionSortAscending': 'Artan düzende sırala',
	'toolbarActionSortDescending': 'Azalan düzende sırala',
	'toolbarActionSortAuto': 'Otomatik (%{sortOrder})',
	'toolbarActionFormat': 'Verileri biçimlendir',
	'toolbarActionFormatAbbreviation': 'Kısalt',
	'toolbarActionFormatNone': 'Otomatik',
	'toolbarActionFilter': 'Süzgeç',
	'toolbarActionTopBottom': 'Üst veya alt',
	'toolbarActionAddShape': 'Şekil ekle',
	'toolbarActionRmvShape': 'Şekli kaldır',
	'toolbarActionToggleShapeDrop': 'İnfografik şekli',
	'toolbarActionToggleShapeDropTitle': 'Bir infografik oluşturun',
	'toolbarActionToggleShapeDropText': 'Bir infografik oluşturmak için bu alana bir şekil sürükleyin.',
	'toolbarActionAggregationType': 'Özetle',
	'toolbarDeleteActionText': 'Sütunu kaldır',
	'toolbarActionFilterLocalKeepSelected': 'Tut',
	'toolbarActionFilterLocalExcludeSelected': 'Çıkar',
	'toolbarActionFilterAllKeepSelected': 'Süzgeç',
	'toolbarActionSimpleCalculation': 'Basit hesaplama',
	'toolbarActionDrillBack': 'Geri',
	'toolbarActionDrillUp': 'Detayı azalt',
	'toolbarActionDrillDown': 'Detaya in',
	'toolbarActionNavigate': 'Dolaş',
	'toolbarActionCreateFilterGroup': 'Yeni bağlantı oluştur',
	'toolbarActionDisconnectFilterGroup': 'Tüm bağlantıları boz',
	'toolbarActionLinkFilterGroup': 'Var olan bir bağlantıya ekle',

	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',

	// Side bar
	'sidebarAdd': 'Ekle',
	'sidebarMultiselect': 'Çoklu seçimi aç/kapat',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'multiselectMsg': '%{count} seçildi',

	'multiselectWithTotalMsg': '%{count} / %{total}',
	'sidebarGoBack': 'Geri git',

	//DataSet pane
	'errorLoadingDataSets': 'Bu veri kümesi yüklenemiyor',
	'errorLoadingDataSetMetaData': 'Bu veri kümesi yüklenemiyor',
	'dataSetPaneLastUpdated': 'Son güncellenme zamanı: %{date}',
	'dataSetPaneDateUnknown': 'Bilinmiyor',
	'sourcePaneLabel': 'Seçilen kaynaklar',
	'addSourceLabel': 'Kaynak ekle',
	'find_label': 'Bul',
	'navigationPathsLabel': 'Dolaşma yolları',

	//widgetlist
	'errorLoadingWidgetList': 'Nesneler yüklenemiyor.',
	'errorLoadingThemeFile': 'Tema tanımı yüklenemiyor',
	'errorLoadingLayoutFile': 'Görünüm yüklenemiyor.',

	//data widget

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'dwErrorLoadingAvailableVisualizations': 'Kullanılabilir görselleştirme tanımları yüklenemiyor',

	'dwErrorLoadingVisualizationNotFound': 'Bir görselleştirme tanımı eksik olduğundan nesne yüklenemiyor',
	'dwErrorLoadingVisualizationListNotFound': 'Görselleştirme yüklenemiyor.',
	'dwErrorRunningQuery': '%{datasetName} veri kümesinden verileri alamıyoruz.',
	'dwErrorGeoData': 'Bir haritadaki coğrafi veriler görüntülenirken sorun oluştu. Lütfen başka bir görselleştirme tipi seçin. ',
	'dwPromptSignonCancelWarning': 'Bu görselleştirme verileri kullanılamıyor. Lütfen doğru kimlik bilgilerini girin.',
	'dwErrorMissingDataset': 'İlişkili veri kümesi \'%{datasetName}\' kullanılabilir olmadığı için görselleştirme yüklenemiyor. ',
	'dwErrorRenderingVisualization': 'Bu görselleştirme yüklenemiyor.',
	'dwErrorVisualizationTooSmall': 'Görselleştirme çok küçük olduğundan barındırdığı içerik görüntülenemiyor. Görselleştirmeyi büyütün veya içerdiği verileri sınırlandırın.',
	'aria_label_datatable': 'Veri tablosu',
	'aria_key_navi_datatable_desc': 'Her bir hücreye gitmek için ok tuşlarını kullanın. İlk satıra gitmek için Control ve Home tuşuna veya son satıra gitmek için Control ve End tuşuna basın.',
	'geomapUnrecognizedLocations': 'Tanınmayan konumlar:',
	'geomapAmbiguousLocations': 'Belirsiz bölgeler:',

	// custom widget
	'customWidget': 'Özel pencere öğesi',
	'customWidgetsTitle': 'Özel pencere öğeleri',
	'noCustomWidgets': 'Özel pencere öğesi yok',

	// Action names
	'toggleContextBar': 'Bağlam çubuğunu aç/kapat',
	'delete': 'Sil',
	'share': 'Paylaş',
	'unshare': 'Paylaşımı Kaldır',
	'rename': 'Yeniden Adlandır',
	'close': 'Kapat',
	'duplicate': 'Yinele',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'retry': 'Yeniden Dene',

	'changeTemplate': 'Şablonu değiştir',

	// Aggregation Types
	'sum': 'Toplam',
	'count': 'Say',
	'countdistinct': 'Farklıları say',
	'avg': 'Ortalama',
	'min': 'Minimum',
	'max': 'Maksimum',
	'custom': 'Özel',
	'calculated': 'Hesaplanmış',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8

	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})', // For example, the sum of Revenue

	//simple calculation
	'percDifferenceOp': 'değişiklik yüzdesi',
	//For example, Profit - Expenses
	'calculationTitle': '%{col1} %{operator} %{col2}',

	'templateWidgetPlaceholderInput': 'Görselleştirme ölçütleri...',
	'QuickAddResultsHeader': 'Veri görselleştirmeleri',
	'NoQuickAddResults': 'Amacınızla eşleşen bir öğe yok. Yeni bir veri kümesi oluşturulsun mu?',
	'NoQuickAddResultsRetry': 'Bir eşleşme bulamıyoruz. Farklı terimlerle yeniden deneyin.',
	'templateWidgetTitle': 'Şablon',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'nullValueLabel': '(boş)',

	'nullValueContent': '(değer yok)',
	'nullValueText': 'Boş değerli',

	// Modelling / Data Shaping
	'textFilterControlRegionLabel': 'Metin süzgeci - %{columnName}',

	'textFilterSelectTab': 'Seç',

	'textFilterConditionTab': 'Bir koşul ayarla',
	'textFilterItemsSelected': '(%{selected})',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'textFilterItemsNotFound': 'Kullanılabilir öğe yok.',

	'textFilterEquals': 'Eşittir',
	'textFilterContains': 'İçerir',
	'textFilterBeginsWith': 'Şununla başlar',
	'textFilterEndsWith': 'Şununla biter',
	'textFilterDoesNotEqual': 'Eşit değildir',
	'textFilterDoesNotContain': 'İçermez',
	'textFilterDoesNotBeginWith': 'Şununla başlamaz',
	'textFilterDoesNotEndWith': 'Şununla bitmez',
	'textFilterSampleText': 'Örneğin: A',

	'textFilterAndButton': 'Ve',
	'textFilterOrButton': 'Veya',

	'dateFilterMessage': 'Bir tarih aralığı seçin',
	'dateRangeControlRegionLabel': 'Tarih aralığı süzgeci - %{columnName}',
	'dateFilterRangeOption': 'Aralık seçeneği',
	'dateFilterDateLabel': 'Tarih',
	'dateFilterBlank': '(boş)',
	'dateFilterBefore': 'Önce',
	'dateFilterAfter': 'Sonra',
	'dateFilterBetween': 'Arasında',
	'dateFilterSampleText': 'YYYY-AA-GG',
	'dateTitle': 'Tarih',
	'dateIncludeBlankLabel': 'Boş tarihi dahil et',

	'timeTitle': 'Zaman',
	'timeFilterMessage': 'Bir zaman aralığı seçin',
	'dateTimeFilterMessage': 'Bir tarih ve zaman aralığı seçin',

	'topbottomNumberOfResultsLabel': 'Sonuç sayısı',
	'topbottomPercentLabel': 'Yüzde',
	'topbottomNumberOfResultsLimit': '%{lower}-%{higher} arasında',
	'topbottomSelectOption': 'Üst veya alt seçeneği',
	'topbottomOptionLabel': 'Göster',
	'searchByLabel': 'Temel',
	'searchNoMatches': 'Eşleşme bulunamadı',
	'topbottomRankColumnLabel': 'Tabloya bir derece sütunu ekle',
	'topbottomNone': 'Yok',
	'topCount': 'Üst sayı',
	'topPercent': 'Üst değer: %',
	'bottomCount': 'Alt sayı',
	'bottomPercent': 'Alt değer: %',
	'topbottomSearchColumn': 'Bir sütun bul',
	'searchColumnAriaLabel': 'Bir sütun bulun. Aranacak sütunun adını yazın, ardından sütunu bir listede bulmak için aşağı oku kullanın',
	'rankColumnLabel': 'Derece (%{columnLabel})',
	'topbottomClearLabel': 'Temizle',

	'rangeFilterControlRegionLabel': 'Aralık süzgeci - %{columnName}',

	// Slider
	'sliderRegionLabel': 'Kaydırıcı denetimi, kaydırıcı tutamaçlarını taşımak için sağ ve sol okları kullanın',
	'sliderHandleLabel': 'Kaydırıcı tutamacı',
	'a11ySliderHandleLabel': 'Kaydırıcı tutamacı %{sliderValue}',
	'sliderInputLabel': 'değer',

	// Refinery - Hidden columns
	'datasetItemsUnavailable': 'Bu görselleştirmede kullanılan bazı veri kümesi öğeleri kullanılamıyor.',
	'datasetItemUnavailable': 'Bu veri kümesi öğesi kullanılamıyor',

	//Authoring topBottom
	'topOperator': 'Üst',
	'bottomOperator': 'Alt',
	//For dimension column. eg: Top 5 by Quantity. %{operator} is topOperator or bottomOperator, %{val} is a number and %{fact} is a column name.
	'topBottomFact': '%{operator} %{value} -  %{columnLabel}',
	//For fact column. eg: Top 10. %{operator} is topOperator or bottomOperator and %{val} is a number.
	'topBottomDimension': '%{operator} %{value}',
	'topBottomTitle': 'Yalnızca bu nesne',
	'deleteTopBottom': 'Üst veya alt sayıyı sil',
	'editTopBottom': 'Üst veya alt sayıyı düzenle',
	'deleteDrillState': 'Geçerli detaylandırma durumunu sil',
	'ariaDeleteDrillStateLabel': 'Üst veya alt sayıyı düzenlemek için ENTER tuşuna basın.',
	'drillUpStateTitle': 'Detayı Azalt',
	'drillDownStateTitle': 'Detaya İn',
	'ariaEditTopBottomLabel': 'Üst veya alt sayıyı düzenlemek için ENTER tuşuna basın.',
	'ariaDeleteTopBottomLabel': 'Üst veya alt sayıyı silmek için DELETE tuşuna basın.',

	// Authoring filtering
	'dimFilterIn': 'Şunu içerir: %{in}',
	'dimFilterNotIn': 'Şunu hariç tutar: %{out}',
	'measureFilterBetween': '%{lowerBound} ve %{upperBound} arasında',
	'measureFilterNotBetween': '%{lowerBound} ve %{upperBound} arasında değil',
	'gtFilter': '%{lowerBound} tarihinden sonra',
	'ltFilter': '%{upperBound} tarihinden önce',
	'notGtFilter': '%{lowerBound} tarihinden sonra değil',
	'notLtFilter': '%{upperBound} öncesinde değil',
	'localFilterTitle': 'Yalnızca bu nesne',
	'globalFilterTitle': 'Tüm nesneler',
	'deleteFilter': 'Süzgeci sil',
	'editFilter': 'Süzgeci düzenle',
	'ariaEditFilterLabel': 'Süzgeci düzenlemek için ENTER tuşuna basın.',
	'ariaDeleteFilterLabel': 'Süzgeci silmek için DELETE tuşuna basın.',

	// Prompts
	'ariaEditPrompt': 'Bilgi istemi değerini değiştirmek için ENTER tuşuna basın',

	'moreDataIndicator': 'Verileriniz %{threshold} öğeye ulaşıldığında kırpıldı. Daha az göstermek için bir süzgeç uygulayın.',

	// data point filtering
	'dataPointFilterTitle': 'Veri noktaları',
	'dataPointFilterIncludeSummary': 'İçerilen %{valueCount} veri noktası',
	'dataPointFilterExcludeSummary': 'Hariç tutulan %{valueCount} veri noktası',

	// DB2 connection page
	'db2Database': 'DB2 Veritabanı (%{jdbcConnection})',
	'db2Title': 'IBM DB2\'ye Bağlan',

	// Database
	'databaseConnectionMessage': 'Veritabanı bağlantısı ayrıntılarınızı sağlayın:',
	'connectionString': 'Veritabanı bağlantısı dizgisi',
	'databaseCredentials': 'Kimlik bilgileri: ',
	'databaseUserName': 'Kullanıcı adı',
	'databasePassword': 'Parola',
	'databaseConnect': 'Bağlan',

	// Twitter Keyword page
	'twitterTitle': 'Twitter',
	'twitterKeywordMessage': 'Bir arama terimi girin:',
	'twitterKeyword': 'Anahtar Sözcük',
	'twitterSearch': 'Ara',

	// NewConnectionView Providers
	'twitterProvider': 'Twitter',
	'dropboxProvider': 'Dropbox',
	'db2Provider': 'DB2',

	'workbookCreateFailed': 'Şu görünüm oluşturulamıyor: %{error} Başarısız işlem: %{lastOp}',

	// Expanded View, Focus View
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'widgetFiltersLabel': 'Pencere öğesi süzgeçleri',
	'missingColumn': 'Eksik: %{columnLabel}',
	'missingFiltering': 'Şu sütun tanıtıcılarında süzgeçler eksik:',
	'heatByLabel': 'Isı:',
	'evColumns': 'Sütunlar',
	'evLocalFilters': 'Yerel süzgeçler',
	'evExpand': 'Genişlet',
	'evFilterTooltip': 'Süzgeç',
	'evAdd': 'Sütun ekle',

	// Navigation View
	'navigationBack': 'Geri',

	// Pinning
	'contentPinFail': 'İçerik toplanamıyor. Daha sonra yeniden dene.',
	'contentPinFailOld': 'İçerik sabitlenemiyor. Daha sonra yeniden dene.',
	'pinRenameFail': 'Pin yeniden adlandırılamıyor. Daha sonra yeniden deneyin.',

	// Layouts
	'dropZoneLabel': 'Ekranı kaplamak için buraya bırakın',

	//Share
	'shareDefaultPageTitle': 'Sayfa %{index}',

	'nextPage': 'Sonraki sayfa',
	'previousPage': 'Önceki sayfa',

	'assetAssembly': 'görünüm',

	'toolbar_save': 'Kaydet',
	'brgr_saveAs': 'Farklı kaydet',
	'brgr_refresh': 'Yenile',

	// Save
	'saving': 'Kaydediliyor...',
	'save_success': 'Görünümünüz kaydedildi.',
	'save_failure': 'Üzgünüz! Görünümünüz kaydedilemedi. Lütfen daha sonra yeniden deneyin.',
	'dashboard_save_success': 'Gösterge panonuz kaydedildi.',

	'geminiLeave': 'IBM Watson Analytics\'ten çıkmak üzeresiniz.',

	'warning': 'Uyarı',
	'missingDataSetData': 'Bu veri kümesi için veriler kullanılamıyor. Kaynağa erişim için veri kümesini yenileyin veya sistem yöneticinizle görüşün.',

	// Calculations
	'error_calculation_in_use': 'Seçilen hesaplama kullanımda olduğundan silinemez.',

	'resize': 'Yeniden Boyutlandır',
	'rotate': 'Döndür',
	'moveHandle': 'Pencere öğesini taşı',
	'expandHandle': 'Genişlet',
	'panHandle': 'Yatay kaydır',

	//Navigation
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'navigateTitle': 'Şuraya git:',

	// Slide out titles
	'shapeSlideoutTitle': 'Şekiller',
	'textSlideoutTitle': 'Metin',
	'mediaSlideoutTitle': 'Ortam',
	'visualizationSlideoutTitle': 'Görselleştirmeler',

	// Board Model Dialog Messages
	'invalidJSONResponse': 'Sağlanan JSON geçersiz. Daha fazla bilgi için hata günlüğüne bakın.',

	// Widget type labels
	'shape_label': 'Şekil',
	'image_label': 'Resim',
	'data_label': 'Grafik',
	'media_label': 'Ortam',
	'text_label': 'Metin',
	'embedMedia_label': 'Ortam',
	'youtube_label': 'YouTube videosu',
	'webpage_label': 'Web Sayfası',

	// **** Smart names for objects ****
	// You might think that one_name is useless, but we have it in case we need to change that resource into one_name_numbered
	'one_name': '%{name}',
	'one_name_numbered': '%{name} (%{number})',
	'noExtraText_shape': 'Şekil',
	'noExtraText_shape_numbered': 'Şekil (%{number})',
	'few_shape': '%{count} şekilden oluşan grup',
	'many_shape': '%{count} şekilden oluşan grup',
	// %{text} is the description of the image, specified in the properties by the user
	'one_image': '%{text} resmi',
	'one_image_numbered': '%{text} resmi (%{number})',
	'noExtraText_image': 'Resim',
	'noExtraText_image_numbered': 'Resim (%{number})',
	'few_image': '%{count} resimlik grup',
	'many_image': '%{count} resimlik grup',
	'noExtraText_text': 'Boş metin kutusu',
	'noExtraText_text_numbered': 'Boş metin kutusu (%{number})',
	'few_text': '%{count} metin kutusu grubu',
	'many_text': '%{count} metin kutusu grubu',
	//pa cube viewer
	'pacubeviewer_no_mapping': 'Cube Viewer',
	'pacubeviewer_named': '%{name} Cube Viewer',
	// Crosstab: values by Row1 (and Column1)
	'crosstab_opt_mapping': '%{values} -  %{row_level1} ve %{column_level1} çağraz sekmesi ',
	'crosstab_opt_mapping_numbered': '%{values} -  %{row_level1} ve%{column_level1} (%{number}) çapraz sekmesi',
	'crosstab_has_mapping': '%{values} - %{row_level1} çapraz sekmesi',
	'crosstab_has_mapping_numbered': '%{values} - %{row_level1} (%{number}) çapraz sekmesi',
	'crosstab_no_mapping': 'Boş çapraz tablo',
	'crosstab_no_mapping_numbered': 'Boş çapraz tablo (%{number})',
	'crosstab_named': '%{name} çapraz tablosu',
	'crosstab_named_numbered': '%{name} çapraz tablosu (%{number})',
	// Grid: first column grid
	'JQGrid_has_mapping': '%{grid_cols} tablosu',
	'JQGrid_has_mapping_numbered': '%{grid_cols} tablosu (%{number})',
	'JQGrid_no_mapping': 'Boş tablo',
	'JQGrid_no_mapping_numbered': 'Boş tablo (%{number})',
	'JQGrid_named': '%{name} tablosu',
	'JQGrid_named_numbered': '%{name} tablosu (%{number})',
	// Hierarchy: level one hierarchy
	'hierarchy_has_mapping': '%{level1} sıradüzeni',
	'hierarchy_has_mapping_numbered': '%{level1} sıradüzeni (%{number})',
	'hierarchy_no_mapping': 'Boş sıradüzen',
	'hierarchy_no_mapping_numbered': 'Boş sıradüzen (%{number})',
	'hierarchy_named': '%{name} sıradüzeni',
	'hierarchy_named_numbered': '%{name} sıradüzeni (%{number})',
	// Legacy map: Region heat by Regions map
	'map_has_mapping': '%{categories} haritası',
	'map_has_mapping_numbered': '%{categories} haritası (%{number})',
	'map_no_mapping': 'Boş harita',
	'map_no_mapping_numbered': 'Boş harita (%{number})',
	'map_named': '%{name} haritası',
	'map_named_numbered': '%{name} haritası (%{number})',
	// Summary value: value summary value
	'summary_has_mapping': '%{actual} özet değeri',
	'summary_has_mapping_numbered': '%{actual} özet değeri (%{number})',
	'summary_no_mapping': 'Boş özet değeri',
	'summary_no_mapping_numbered': 'Boş özet değeri (%{number})',
	'summary_named': '%{name} özet değeri',
	'summary_named_numbered': '%{name} özet değeri (%{number})',

	// KPI: actual value, optional time
	'kpi_opt_mapping': '%{actual} - %{sparkline.time} KPI',
	'kpi_opt_mapping_numbered': '%{actual} - %{sparkline.time} KPI (%{number})',
	'kpi_has_mapping': '%{actual} KPI',
	'kpi_has_mapping_numbered': '%{actual} KPI (%{number})',
	'kpi_no_mapping': 'Boş KPI',
	'kpi_no_mapping_numbered': 'Boş KPI (%{number})',
	'kpi_named': '%{name} KPI\'si',
	'kpi_named_numbered': '%{name} KPI\'si (%{number})',

	// (Infographic summary) Infographic: value infographic
	'infographicSummary_has_mapping': '%{actual} infografiği',
	'infographicSummary_has_mapping_numbered': '%{actual} infografiği (%{number})',
	'infographicSummary_no_mapping': 'Boş infografik',
	'infographicSummary_no_mapping_numbered': 'Boş infografik (%{number})',
	'infographicSummary_named': '%{name} infografiği',
	'infographicSummary_named_numbered': '%{name} infografiği (%{number})',
	'noExtraText_youtube': 'YouTube videosu',
	'noExtraText_youtube_numbered': 'YouTube videosu (%{number})',
	// %{text} is the user-provided title of the video
	'one_youtube': '%{text} YouTube videosu',
	'one_youtube_numbered': '%{text} YouTube videosu (%{number})',
	'few_youtube': '%{count} YouTube videosu grubu',
	'many_youtube': '%{count} YouTube videosu grubu',
	'noExtraText_embedMedia': 'Ortam bağlantısı',
	'noExtraText_embedMedia_numbered': 'Ortam bağlantısı (%{number})',
	// %{text} is the user-provided title of the media link
	'one_embedMedia': '%{text} ortam bağlantısı',
	'one_embedMedia_numbered': '%{text} ortam bağlantısı (%{number})',
	'few_embedMedia': '%{count} ortam bağlantısı grubu',
	'many_embedMedia': '%{count} ortam bağlantısı grubu',
	'noExtraText_media': 'Ortam',
	'noExtraText_media_numbered': 'Ortam (%{number})',
	// %{text} is the user-provided title of the media link
	'one_media': '%{text} ortamı',
	'one_media_numbered': '%{text} ortamı (%{number})',
	'few_media': '%{count} ortam grubu',
	'many_media': '%{count} ortam grubu',
	'noExtraText_webpage': 'Web sayfası',
	'noExtraText_webpage_numbered': 'Web sayfası (%{number})',
	// %{text} is the user-provided title of the web page
	'one_webpage': '%{text} web sayfası',
	'one_webpage_numbered': '%{text} web sayfası (%{number})',
	'few_webpage': '%{count} web sayfası grubu',
	'many_webpage': '%{count} web sayfası grubu',
	'one_unknown': 'Bir nesne',
	'one_unknown_numbered': 'Bir nesne (%{number})',
	'few_unknown': '%{count} nesne grubu',
	'many_unknown': '%{count} nesne grubu',

	//a11y label for the left/right arrow for navigation path

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'next': 'İleri',
	'previous': 'Önceki',
	//a11y description

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'current_nav_group': 'Geçerli dolaşma grubu: %{navigation_group_name}',

	//Page Context
	'filterBlank': '(boş)',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'errMsgFilterItemGenericTitle': 'Süzgeç değerleri yüklenemedi',
	'editTimelineHighlight': 'Vurguyu düzenle',

	'filterDockChevronLeft': 'Verileri kaydır',
	'filterDockChevronRight': 'Verileri kaydır',
	'expand': 'Genişlet',
	'collapse': 'Daralt',

	//Reset Dashboard
	'dashboardResetTitle': 'Gösterge panosunu sıfırla',
	'dashboardResetMessage': 'Bu gösterge panosuna uygulanan tüm değişiklikleri sıfırlamak istediğinizden emin misiniz?',
	'dashboardResetToast': 'Gösterge panonuz sıfırlandı.',

	//Generate PDF
	'buildingPDF': 'PDF oluşturuluyor...',
	'exportPDF': 'PDF olarak dışa aktar',
	'pageSize': 'Sayfa boyutu',
	'orientation': 'Yön',
	'filtersPresentPDF': 'Önceki sayfada görselleştirmelere uygulanan süzgeçler:',
	'errorPDF': 'PDF oluşturulamıyor. Lütfen yenileyin ve tekrar deneyin.',
	'errorPrintPDF': 'PDF oluşturulamıyor. Lütfen yeniden deneyin.',
	'printPDFInfo': 'Belgeleri görüntüle',
	'pdfWidget': 'Pencere bileşeni',
	'includeFilters': 'Süzgeç ayrıntılarını göster',
	'portrait': 'Dikey',
	'landscape': 'Yatay',
	'letter': 'Letter',
	'legal': 'Legal',
	'a4':'A4',
	'tabloid':'Tabloid',

	'toastUpgradeDone': 'Gösterge panonuz yükseltildi. En iyi performansı korumak için şimdi kaydedin.',

	'migratingDashboard': 'Gösterge panosu verilerinizin taşınması gerekir, geçiş tamamlanınca gösterge panosu kaydedilecek...',
	'migrateDone': 'Gösterge panosu verileriniz taşındı.',
	'migrateNoPermission': 'Gösterge panosu verilerinizin taşınması gerekir; bu, yazma izni gerektirir; görselleştirmeler hatayla görsel olarak gerçekleştirilir.',
	'migratingDataSourcesFailed': 'bir ya da birkaç veri kaynağı veri geçişinde başarısız oldu',

	'ariaFullScreenMessage': 'Tam ekrandan çıkmak için Escape tuşuna basın',

	/**********************************************
	*******************LIVE WIDGET*****************
	***********************************************/
	// Hierarchy Packed Bubble
	'LIVE_hierarchy_packed_bubble_has_mapping': '%{categories} paketli sıradüzen kabarcık grafiği',
	'LIVE_hierarchy_packed_bubble_has_mapping_numbered': '%{categories} paketli sıradüzen kabarcık grafiği (%{number})',
	'LIVE_hierarchy_packed_bubble_no_mapping': 'Boş paketli sıradüzen kabarcık grafiği',
	'LIVE_hierarchy_packed_bubble_no_mapping_numbered': 'Boş paketli sıradüzen kabarcık grafiği (%{number})',
	'LIVE_hierarchy_packed_bubble_named': '%{name} paketli sıradüzen kabarcık grafiği',
	'LIVE_hierarchy_packed_bubble_named_numbered': '%{name} paketli sıradüzen kabarcık grafiği (%{number})',

	// Marimekko
	'LIVE_marimekko_has_mapping': '%{values} marimekko grafiğine göre %{categories}',
	'LIVE_marimekko_has_mapping_numbered': '%{values} marimekko grafiğine (%{number}) %{categories} göre',
	'LIVE_marimekko_no_mapping': 'Boş marimekko grafiği',
	'LIVE_marimekko_no_mapping_numbered': 'Boş marimekko grafiği (%{number})',
	'LIVE_marimekko_named': '%{name} marimekko grafiği',
	'LIVE_marimekko_numbered': '%{name} marimekko grafiği(%{number})',

	// Sunburst
	'LIVE_sunburst_has_mapping': '%{values} güneş ışığı grafiği',
	'LIVE_sunburst_has_mapping_numbered': '%{values} güneş ışığı grafiği (%{number})',
	'LIVE_sunburst_no_mapping': 'Boş güneş ışığı grafiği',
	'LIVE_sunburst_no_mapping_numbered': 'Boş güneş ışığı grafiği (%{number})',
	'LIVE_sunburst_named': '%{name} güneş ışığı grafiği',
	'LIVE_sunburst_named_numbered': '%{name} güneş ışığı grafiği (%{number})',

	// Driver Analysis
	'LIVE_decision_analysis_has_mapping': '%{values} sürücü analizi grafiği',
	'LIVE_decision_analysis_has_mapping_numbered': '%{values} sürücü analizi grafiği (%{number})',
	'LIVE_decision_analysis_no_mapping': 'Boş sürücü analizi grafiği',
	'LIVE_decision_analysis_no_mapping_numbered': 'Boş sürücü analizi grafiği (%{number})',
	'LIVE_decision_analysis_named': '%{name} sürücü analizi grafiği',
	'LIVE_decision_analysis_named_numbered': '%{name} sürücü analizi grafiği (%{number})',

	// Line and Column
	'LIVE_line_column_opt_mapping': '%{columnValue} ve %{lineValue} satır ve sütun grafiğine göre %{categories}',
	'LIVE_line_column_opt_mapping_numbered': '%{columnValue} ve %{lineValue} satır ve sütun grafiğine göre %{categories}  (%{number})',
	'LIVE_line_column_has_mapping': '%{columnValue} ve %{lineValue} satır ve sütun grafiği',
	'LIVE_line_column_has_mapping_numbered': '%{columnValue} ve %{lineValue} satır ve sütun grafiğine göre %{categories}  (%{number})',
	'LIVE_line_column_no_mapping': 'Boş satır ve sütun grafiği',
	'LIVE_line_column_no_mapping_numbered': 'Boş satır ve sütun grafiği (%{number})',
	'LIVE_line_column_named': '%{name} satır ve sütun grafiği',
	'LIVE_line_column_named_numbered' : '%{name} satır ve sütun grafiği (%{number})',

	// Bubble chart
	'LIVE_bubble_chart_has_mapping': '%{y} ve %{size} kabarcık grafiğine göre %{x}',
	'LIVE_bubble_chart_has_mapping_numbered': '%{y} ve %{size} kabarcık grafiğine göre %{x} (%{number})',
	'LIVE_bubble_chart_no_mapping': 'Boş kabarcık grafiği',
	'LIVE_bubble_chart_no_mapping_numbered': 'Boş kabarcık grafiği (%{number})',
	'LIVE_bubble_chart_named': '%{name} kabarcık grafiği',
	'LIVE_bubble_chart_named_numbered': '%{name} kabarcık grafiği (%{number})',

	// Bullet chart
	'LIVE_bullet_has_mapping': '%{actual}  madde işareti grafiği',
	'LIVE_bullet_has_mapping_numbered': '%{actual} madde işareti grafiği (%{number})',
	'LIVE_bullet_no_mapping': 'Boş madde işareti grafiği',
	'LIVE_bullet_no_mapping_numbered': 'Boş madde işareti grafiği (%{number})',
	'LIVE_bullet_named': '%{name} madde işareti grafiği',
	'LIVE_bullet_named_numbered': '%{name} madde işareti grafiği (%{number})',

	// powered by feature
	'ibmDb2': 'IBM Db2',
	'dashboardPoweredByPrefix': 'Bu gösterge panosundaki verilerin sağlanma temeli',
	'showFooterToggleButtonText': 'Altbilgiyi göster',
	'showFooterSectionText': 'Altbilgi'

});
